import { LiveEventData, LivePlayerDataEvent } from "./lib/game_snacks/ILiveMultiplayer";
import { Profile } from "./lib/game_snacks/IUser";
import PRNG from "./lib/PRNG";


export default class Session
{
    private _profile: Profile = null;
    private _arrPlayerProfile: Array<Profile> = null;
    private _prng: PRNG = null;
    private _isInvite: boolean = null;
    private _gameType: game_type = null;
    private _arrGameEvent: Array<LiveEventData> = null;
    private _arrRoomEvent: Array<LiveEventData> = null;
    private _privateRoomUrl: string = null;
    private _isGameStarted: boolean = null;
    private _isLeaveGame: boolean = null;

    private readonly _kGameRoomSize: number = 4;

    private static _instance: Session = null;


    public set profile( value: Profile ) { this._profile = value; }
    public set room( value: Array<Profile> ) { this._arrPlayerProfile = value; }
    public set prng( value: PRNG ) { this._prng = value; }
    public set isInvite( value: boolean ) { this._isInvite = value; }
    public set gameType( value: game_type ) { this._gameType = value; }
    public set privateRoomUrl( value: string ) { this._privateRoomUrl = value; }
    public set isGameStarted( value: boolean ) { this._isGameStarted = value; }
    public set isLeaveGame( value: boolean ) { this._isLeaveGame = value; }

    public get profile(): Profile { return this._profile; }
    public get room(): Array<Profile> { return this._arrPlayerProfile; }
    public get prng(): PRNG { return this._prng; }
    public get isInvite(): boolean { return this._isInvite; }
    public get gameType(): game_type { return this._gameType; }
    public get privateRoomUrl(): string { return this._privateRoomUrl; }
    public get isGameStarted(): boolean { return this._isGameStarted; }
    public get isLeaveGame(): boolean { return this._isLeaveGame; }
    public get gameEvents(): Array<LiveEventData> { return this._arrGameEvent; }
    public get roomEvents(): Array<LiveEventData> { return this._arrRoomEvent; }
    public get kGameRoomSize(): number { return this._kGameRoomSize; }

    public static get i(): Session
    {
        if ( !Session._instance )
        {
            Session._instance = new Session();
        }

        return Session._instance;
    }

    private constructor() 
    {
        this._isInvite = false;
        this._isGameStarted = false;
        this._isLeaveGame = false;

        this._arrPlayerProfile = [];
        this._arrGameEvent = [];
        this._arrRoomEvent = [];
    }

    public reset(): void
    {
        if ( this._profile )
        {
            this._profile.isReady = false;
        }
        this._prng = null;
        this._isInvite = false;
        this._gameType = null;
        this._privateRoomUrl = null;
        this._isGameStarted = false;
        this._isLeaveGame = false;

        this._arrPlayerProfile.splice( 0 );
        this._arrGameEvent.splice( 0 );
        this._arrRoomEvent.splice( 0 );
    }
}

export const enum game_type
{
    MATCHMAKING = 0,
    PRIVATE_1_VS_4
}

export const enum team_id
{
    RED = 0,
    BLUE
}